import { BlockProps, IBlockLocation } from '../../content-blocks/type';
import { FacebookBlockProps } from './type';

interface Props {
  key: string;
  label: string;
  location: IBlockLocation;
}

export const createFacebookBlock = (props: Props): FacebookBlockProps => {
  return {
    type: 'facebook',
    value: props.label,
    width: 20,
    height: 20,
    isVisible: false,
    x: 0,
    y: 0,
    fontSize: 12,
    isBold: false,
    isItalics: false,
    isCapsLocks: false,
    ...props,
  };
};

export function isFacebookBlock(
  block: BlockProps,
): block is FacebookBlockProps {
  return block.type === 'facebook';
}
